<div *ngIf="!showMissingAttributesModal" class="custom-modal-backdrop">
  <div class="custom-modal">
    <div class="modal-top-section">
      <div class="modal-icon-wrapper">
        <img src="assets/images/icons/warning-icon.svg" alt="Warning" />
      </div>
      <div class="modal-content-wrapper">
        <h3 class="modal-title">Missing Item Attributes</h3>
        <p class="modal-message">
          {{ products.length }} item attributes (<strong>Dimensions, Weight</strong>) are missing.
        </p>
      </div>
    </div>

    <div class="act-btn-container w-100">
      <button class="black-btn custom-btn" (click)="onCancel()">Cancel</button>
      <button
        class="action-btn custom-btn"
        data-bs-toggle="offcanvas"
        data-bs-target="#updateProduct"
        aria-controls="offcanvasBottom"
        (click)="onUpdate()"
      >
        Update Attributes
      </button>
    </div>
  </div>
</div>
<div
  class="offcanvas offcanvas-bottom offcanvas-body"
  tabindex="-1"
  id="updateProduct"
  style="height: 80vh; display: block"
  aria-labelledby="offcanvasBottomLabel"
>
  <div class="offcanvas-header p-0">
    <h5 class="offcanvas-title lg-header-text" id="offcanvasBottomLabel">Update Item Attributes</h5>
    <button
      type="button"
      class="btn-close text-reset"
      (click)="onCancel()"
      aria-label="Close"
    ></button>
  </div>

  <div class="offcanvas-body p-0 small">
    <div class="accr-wrapper" id="rulesWrapperParent">
      <div class="accordion mb-4" *ngFor="let product of products; let i = index">
        <div class="accordion-item custom-accordion-item">
          <h2 class="accordion-header" [id]="'headingItem' + i">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#collapseItem' + i"
              aria-expanded="true"
              [attr.aria-controls]="'collapseItem' + i"
            >
              <span>{{ getShortProductName(product.name) || 'Unnamed Item' }}</span>
            </button>
          </h2>

          <div
            [id]="'collapseItem' + i"
            class="accordion-collapse collapse show"
            [attr.aria-labelledby]="'headingItem' + i"
          >
            <div class="accordion-body">
              <div class="item-card">
                <div class="item-header">
                  <img
                    [src]="
                      product.productImages &&
                      product.productImages.length > 0 &&
                      product.productImages[0].url
                        ? product.productImages[0].url
                        : 'assets/images/icons/ic_demo_img.svg'
                    "
                    alt=""
                  />
                  <div>
                    <h6>{{ getShortProductName(product.name) }}</h6>
                    <p>SKU: {{ product.sku }}</p>
                  </div>
                </div>

                <div class="section-label">Dimensions</div>

                <div class="row g-2">
                  <div class="col-12">
                    <label>Height <span>*</span></label>
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="product.height"
                      (ngModelChange)="onInputChange(product, 'height', $event)"
                      placeholder="Enter height"
                    />
                  </div>

                  <div class="col-12">
                    <label>Width <span>*</span></label>
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="product.width"
                      (ngModelChange)="onInputChange(product, 'width', $event)"
                      placeholder="Enter width"
                    />
                  </div>

                  <div class="col-12">
                    <label>Length <span>*</span></label>
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="product.length"
                      (ngModelChange)="onInputChange(product, 'length', $event)"
                      placeholder="Enter length"
                    />
                  </div>

                  <div class="col-12">
                    <label>Unit <span>*</span></label>
                    <ng-select
                      [ngModel]="product.dimensionUnit || null"
                      (ngModelChange)="onInputChange(product, 'dimensionUnit', $event)"
                      [clearable]="false"
                      [searchable]="false"
                      dropdownPosition="top"
                      placeholder="Select unit"
                    >
                      <ng-option *ngFor="let key of dimensionUnitKeys" [value]="dimensionUnits[key]">
                        {{ dimensionUnits[key] | enumLabel: dimensionUnits }}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>

                <div class="section-label mt-3">Weight</div>

                <div class="row g-2">
                  <div class="col-12">
                    <label>Weight <span>*</span></label>
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="product.weight"
                      (ngModelChange)="onInputChange(product, 'weight', $event)"
                      placeholder="Enter weight"
                    />
                  </div>

                  <div class="col-12">
                    <label>Unit <span>*</span></label>
                    <ng-select
                      [ngModel]="product.weightUnit || null"
                      (ngModelChange)="onInputChange(product, 'weightUnit', $event)"
                      [clearable]="false"
                      [searchable]="false"
                      dropdownPosition="top"
                      placeholder="Select unit"
                    >
                      <ng-option *ngFor="let key of weightUnitKeys" [value]="weightUnits[key]">
                        {{ weightUnits[key] | enumLabel: weightUnits }}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary w-100 m-0"
      [disabled]="!isAllProductsValid()"
      (click)="onProductUpdate()"
      data-bs-dismiss="offcanvas"
    >
      Update Attributes
    </button>
  </div>
</div>
